import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PersonIcon = (props: IconProps) => (
  <Icon width="14px" height="14px" viewBox="0 0 14 14" {...props}>
    <path d="M7.00004 7.00065C8.28921 7.00065 9.33337 5.95648 9.33337 4.66732C9.33337 3.37815 8.28921 2.33398 7.00004 2.33398C5.71087 2.33398 4.66671 3.37815 4.66671 4.66732C4.66671 5.95648 5.71087 7.00065 7.00004 7.00065ZM7.00004 8.16732C5.44254 8.16732 2.33337 8.94898 2.33337 10.5007V11.6673H11.6667V10.5007C11.6667 8.94898 8.55754 8.16732 7.00004 8.16732Z" />
  </Icon>
);
export default memo(PersonIcon);
